import constants from './constants'

const MODE = 'prod'
const localBasePath = 'http://localhost:4444'
const basePath = MODE.toString() === 'prod' ? 'https://transfer.keysoft-dev.com' : localBasePath

const config = {
	mode: MODE,
	logLevel: MODE.toString() === 'prod' ? 'error' : 'trace',
	main: {
		service_url: `${basePath}/api/v1`,
    	public_url: `${basePath}/api/public-files`
	},
	wsConfig: {
		connection: `${basePath}/`,
		options: {
			path: '/api/events',
			transports: ['websocket', 'polling']
		}
	},
	data_formats: {
		db: {
			date: 'YYYY-MM-DD',
			date_time: 'YYYY-MM-DD HH:mm:ss'
		},
		user: {
			date: 'DD.MM.YYYY',
			date_time: 'DD.MM.YYYY HH:mm'
		},
		momment: {
			date: 'll',
			date_time: 'lll'
		}
	},
	file_size: 500,
	constants
} 

export default config

export { config }
